module.exports = __webpack_public_path__ + "files/3d988fde28cc53636261fbfe2732896e.png";